import { createFileRoute, Navigate } from '@tanstack/react-router';
import { z } from 'zod';

import { navContextSearchSchema } from '~/features/catalog-enrichment/utils/nav-context';

/** `from`/`back` (S12) are carried over so the batch keeps its back link. */
const searchSchema = z.object({ ...navContextSearchSchema });

/** Retry options are a sheet on the batch's Overview now (guide part 2 §4.9); old links land there. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/recovery',
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <Navigate
      to="/catalog-enrichment/runs/$runId"
      params={{ runId }}
      search={{ ...search, retry: true }}
      replace
    />
  );
}
